module.exports = {"130274103":"王滩镇","130274451":"社区管理服务中心","130274452":"唐山湾国际旅游岛","130274455":"大清河"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130274.json
// module id = 181
// module chunks = 0